<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ productPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/cpzy' }">{{ navbar.production }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">
            {{ activeNameText }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- tabs -->
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="productPage.tabs[0]" name="1">
          <Information v-if="activeName === '1'"></Information>
        </el-tab-pane>
        <el-tab-pane :label="productPage.tabs[1]" name="2">
          <Video v-if="activeName === '2'"></Video>
        </el-tab-pane>
        <el-tab-pane :label="productPage.tabs[2]" name="3">
          <Problem v-if="activeName === '3'"></Problem>
        </el-tab-pane>
        <!-- <el-tab-pane label="VR" name="4"></el-tab-pane> -->
      </el-tabs>
    </div>

    
    <block v-show="activeName === '0'">
      <!-- 企业宣传资料 -->
      <div class="cp_one cp_item">
        <div style="width: 45%;">
          <div class="one_tit">
            <img src="../../assets/images/cpzy/i26.png" alt="" />
            {{ productPage.tabs[0] }}
          </div>
          <div class="one_ul">
            <span class="li_line"></span>
            <div
              class="one_li"
              v-for="(item, index) in oneList"
              :key="item.id"
              v-if="index < 5"
              @click="downloadPDF(item)"
            >
              <div style="display: flex;align-items:center;color: #545454;">
                <span class="menu_single">
                  <img src="../../assets/images/cpzy/i26.png" alt="" />
                </span>
                <span>{{ item[`${currentLang.prefix}title`] }}</span>
              </div>
              <img src="../../assets/images/cpzy/i27.png" alt="" />
            </div>
          </div>
          <div class="dynamic_btn" @click="goXczl">
            <span>MORE</span>
            <img
              class="more_btn"
              src="../../assets/images/public/arrow1.png"
              alt=""
            />
          </div>
        </div>
        <div class="bg">
          <img src="../../assets/images/cpzy/i28.png"  />
        </div>
      </div>
      <!-- 企业视频展示 -->
      <div class="cp_two cp_item">
        <div class="two_fir">
          <div class="bg">
            <img src="../../assets/images/cpzy/i33.png" />
          </div>
          <div style="width: 45%;">
            <div class="one_tit">
              <img src="../../assets/images/cpzy/i30.png" alt="" />
              {{ productPage.tabs[1] }}
            </div>
            <div class="one_ul">
              <span class="li_line"></span>
              <div
                class="one_li"
                v-for="(item, index) in twoList"
                :key="item.id"
                v-if="index < 5"
                @click="playVideo(item)"
              >
                <div style="display: flex;align-items:center;color: #545454;">
                  <span class="menu_single">
                    <img src="../../assets/images/cpzy/i30.png" alt="" />
                  </span>
                  <span>{{ item[`${currentLang.prefix}title`] }}</span>
                </div>
                <img src="../../assets/images/cpzy/i27.png" alt="" />
              </div>
            </div>
            <div class="dynamic_btn" @click="goQysp">
              <span>MORE</span>
              <img
                class="more_btn"
                src="../../assets/images/public/arrow1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 常见技术问题 -->
      <div class="cp_one cp_item">
        <div style="width: 45%;">
          <div class="one_tit">
            <img src="../../assets/images/cpzy/i32.png" alt="" />
            {{ productPage.tabs[2] }}
          </div>
          <div class="one_ul">
            <span class="li_line"></span>
            <div class="one_li" v-for="(item,index) in threeList" :key="item.id" v-if="index < 5" @click="toDetails(index)">
              <div style="display: flex;align-items:center;color: #545454;">
                <span class="menu_single">
                  <img src="../../assets/images/cpzy/i32.png" alt="" />
                </span>
                <span>{{ item[`${currentLang.prefix}title_desc`] }}</span>
              </div>
              <img src="../../assets/images/cpzy/i27.png" alt="" />
            </div>
          </div>
          <div class="dynamic_btn" @click="goJs">
            <span>MORE</span>
            <img
              class="more_btn"
              src="../../assets/images/public/arrow1.png"
              alt=""
            />
          </div>
        </div>
        <div class="bg">
          <img src="../../assets/images/cpzy/i31_1.png" style="transform: scale(1.03);"  />
        </div>
      </div>
    </block>

    <div class="footer">
      <footer-wrap></footer-wrap>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600"
      :before-close="handleClose"
    >
      <div slot="title" style="display: flex">
        <div class="el-dialog__title" style="margin-right: 10px">
          {{ title }}
        </div>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-document-copy"
          @click="copy()"
          >{{ productPage.copyText }}</el-button
        >
      </div>
      <custom-video
        :url="videoUrl"
        :poster="currentInfo.image ? currentInfo.image : ''"
      ></custom-video>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  companyPdfList,
  companyVideoList,
  getArticleList,
  getProductQuestion
} from "@/utils/http.js";
import Information from "./information.vue";
import Video from "./video.vue";
import Problem from "./problem.vue";
export default {
  inject: ['reload'],

  components: {
    Information,
    Video,
    Problem
  },
  data() {
    return {
      activeNameText: "",
      activeName: "0",
      oneList: [],
      twoList: [],
      threeList: [],
      dialogVisible: false,
      videoUrl: "",
      title: "",
      currentInfo: {},
      // footShow:false
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productPage() {
      return this.currentLang.config.productPage
    },
    navbar() {
      return this.currentLang.config.navbar
    },
  },

  mounted() {
    if(this.$route.query.index){
      this.activeName = this.$route.query.index
      if(this.activeName && this.activeName > 0){
          this.activeNameText = this.productPage.tabs[this.activeName - 1]
      }
    }
    // this.getProductNameList();
    this.fetchFileList();
    this.fetchVideoList();
    this.getQuestionList();
  },
  methods: {
    copy(videoUrl) {
      navigator.clipboard
        .writeText(videoUrl ? videoUrl : this.videoUrl)
        .then(() => {
          this.$message.success("链接复制成功");
        })
        .catch(() => {
          this.$message.error("链接复制失败");
        });
    },

    getProductNameList() {
      companyPdfList().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.oneList = res.data.list;
        }
      });
    },

    fetchFileList() {
      const query = {
        cate_id: 38,
        page: this.page,
        limit: 12,
      }
      getArticleList(query).then((res) => {
        if (res.code === 1) {
          this.oneList = res.data.list;
        }
      });
    },

    getVideoNameList() {
      companyVideoList().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.twoList = res.data.list;
        }
      });
    },
    fetchVideoList() {
      const query = {
        cate_id: 39,
        page: 1,
        limit: 6,
      }
      getArticleList(query).then((res) => {
        if (res.code === 1) {
          this.twoList = res.data.list;
        }
      });
    },
    getQuestionList() {
      getProductQuestion().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.threeList = res.data.list;
        }
      });
    },
    handleClick(tab) {
      this.activeNameText = tab && tab.label ? tab.label : this.activeNameText;
      this.$router.push({ path: "/cpzy", query: {index:this.activeName}})
      this.reload();
    },
    goXczl() {
      this.activeName = "1";
      this.handleClick()
    },
    goQysp() {
      this.activeName = "2";
      this.handleClick()
    },
    goJs() {
      this.activeName = "3";
      this.handleClick()
    },
    downloadPDF(item) {
      // 要下载的文件路径
      var fileUrl = item.files;
      // 创建一个隐藏的<a>元素，用于下载文件
      var a = document.createElement("a");
      a.href = fileUrl;
      // a.download = item[`${this.currentLang.prefix}title`]; // 可以自定义下载文件的名称
      a.style.display = "none";
      a.target = '_blank'
      // 将<a>元素添加到页面上
      document.body.appendChild(a);
      // 触发点击事件，开始下载
      a.click();
      // 下载完成后，移除<a>元素
      document.body.removeChild(a);
    },
    playVideo(item) {
      this.currentInfo = item;
      this.title = item[`${this.currentLang.prefix}title`];
      this.videoUrl = item.files;
      this.dialogVisible = true;
    },
    handleClose() {
      this.videoUrl = "";
      this.currentInfo = {}
      this.dialogVisible = false;
    },
    toDetails(index){
      this.$router.push({ path: "/detail", query: {index:index}})
    }
  }
};
</script>
<style lang="scss" scoped>
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.cp_item {
  width: 100%;
  margin: 50px auto 0;
  padding: 20px 0;

  .bg {
    overflow: hidden;
    width: 600px;
    height: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bg img {
    width: 100%;
  }
}

.cp_one {
  width: 1300px;
  display: flex;
  justify-content: space-between;
}

.cp_two {
  width: 100%;
  height: auto;
  background: #f5f5f5;

  .two_fir {
    width: 1300px;
    margin: 50px auto;
    display: flex;
    justify-content: space-between;
  }
}

.one_tit {
  display: flex;
  align-items: center;
  color: #003359;
  font-size: 26px;

  img {
    margin-right: 20px;
  }
}

.one_ul {
  overflow: hidden;
  height: 340px;

  .one_li,
  .li_line {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #5b5b5b;
    align-items: center;
    margin: 20px 0;
    padding-bottom: 15px;
    justify-content: space-between;
    cursor: pointer;

    .menu_single {
      width: 5px;
      height: 5px;
      width: 18px;
      height: 18px;
      margin-right: 20px;
      margin-right: 10px;
    }

    .menu_single img {
      width: 100%;
      height: 100%;
      vertical-align: baseline;
    }

    img {
      width: 20px;
      vertical-align: bottom;
    }
  }
}

.dynamic_btn {
  width: 140px;
  height: 45px;
  margin-top: 50px;
  margin-top: 100px;
  background: #e8363e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  .more_btn {
    width: 40px;
    margin-left: 10px;
  }
}

.dynamic_btn:hover {
  cursor: pointer;
}

.footer {
  margin-top: 80px;
}

// .el-tabs__nav-wrap {
//   margin-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__nav {
//   border: 0;

// }

// .el-tabs--card>.el-tabs__header {
//   border: 0;
//   width: 700px;
//   margin: auto;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item {
//   border-left: 0;
//   border-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
//   background: #646464;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
//   padding-left: 50px;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
//   padding-right: 50px;
// }

// .el-tabs__item {
//   height: 40px;
//   color: gray;
//   padding: 0 50px;
// }

// .el-tabs__item.is-active {
//   color: white;
// }

// .el-tabs__nav-wrap {
//   height: 40px;
// }

// .el-tabs__item:hover {
//   color: gray;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active:hover {
//   color: white;
// }

// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #e8363e;
// }
</style>



// WEBPACK FOOTER //
// src/pages/cpzy/cpzy.vue